// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1WA8o","infoBtn":"quickbooks_infoBtn__2ncdd","formBox":"quickbooks_formBox__3BsMS","formFooter":"quickbooks_formFooter__2NxnV"};